import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProductCards from "./ProductCards";
import sampleProductImg from "../../Assets/sample_product_img.png";
import product_img_1 from "../../Assets/product_1.png";
import product_img_2 from "../../Assets/product_2.jpg";
import product_img_3 from "../../Assets/product_3.jpg";
import product_img_4 from "../../Assets/product_4.png";

//https://bac.co.kr/product/product_list/etc/23 총 4개
//인증현황? 탭 하나 만들기. 사업자등록증 및 여러개. 타이틀 필요한가?
function Products() {
  return (
    <Container fluid className="products-section">
      <Container>
        <div className="products-header">
          <h1 className="products-heading">제품 소개</h1>
          <p className="products-description">
            제품에 대한 자세한 문의는 <br className="mobile-line-break" />
            전화 또는 이메일로 보내주세요.
          </p>
        </div>

        <Row className="products-grid">
          <Col md={6} className="product-item">
            <ProductCards
              imgPath={product_img_1}
              category="동진에어텍"
              title="에어컨"
              description="실내 온도와 습도를 조절하여 쾌적한 환경을 제공하는 냉난방 시스템입니다."
              url="https://bac.co.kr/product/product_list/air/"
            />
          </Col>

          <Col md={6} className="product-item">
            <ProductCards
              imgPath={product_img_2}
              category="동진에어텍"
              title="냉동기기"
              description="저온 냉동 및 냉장 보관을 위한 산업용 및 상업용 냉동 설비입니다."
              url="https://bac.co.kr/product/product_list/freezer/"
            />
          </Col>
          <Col md={6} className="product-item">
            <ProductCards
              imgPath={product_img_3}
              category="동진에어텍"
              title="공조기기"
              description="기 순환, 환기, 온습도 조절을 통해 실내 공기질을 관리하는 시스템입니다."
              url="https://bac.co.kr/product/product_list/equipment/"
            />
          </Col>
          <Col md={6} className="product-item">
            <ProductCards
              imgPath={product_img_4}
              category="동진에어텍"
              title="기타공조"
              description="덕트, 배관, 제어시스템 등 공조설비의 부대시설 및 특수 장비입니다."
              url="https://bac.co.kr/product/product_list/etc/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Products;
